import type { Logger } from "@expert/logging";
import type { Partner } from "@expert/shared-types";
import ky from "ky";
import { defaultHeaders, defaultTimeoutInMS } from "../types";

interface VerifyCustomerPayload {
    clientChannelId?: string;
    mdn: string;
    partner: Partner;
    pin: string;
    callSid: string;
    sessionId: string;
}

interface VerifyCustomerResult {
    token: string;
}

export const verifyCustomer = async (ssoAccessToken: string, payload: VerifyCustomerPayload, logger: Logger) => {
    try {
        const url = `${import.meta.env.VITE_API_BASE_URL}/api/device-activation/v1/verify-customer`;
        const resp = await ky.post(url, {
            headers: {
                ...defaultHeaders,
                Authorization: `Bearer ${ssoAccessToken}`,
            },
            json: payload,
            timeout: defaultTimeoutInMS,
        });

        const { token } = await resp.json<VerifyCustomerResult>();
        return { token };
    } catch (error) {
        logger.error({ error }, `Error: Could not verify customer.`);
        return { token: undefined };
    }
};
